
module.exports = function getResource(label, vars = []) {
    const resources = {
        getItShippedTitle: `Faites livrer (${vars[0]})`,
        getItSooner: 'Get It Sooner'
    };

    return resources[label];
};
